import SelectDevice from './views/SelectDevice'
import Store from '../store'

const DeviceRouter = {
  path: '/device/select',
  name: 'device-select',
  component: SelectDevice,
  props: true,
  meta: {
    dark: true,
    loader: true
  }
}

const DeviceFilter = async (to, from, next) => {
  if (to.path.startsWith('/device') || to.path.startsWith('/auth')) {
    next()
  } else {

    const deviceId = to.params ? to.params.deviceId : null
    // Set/Load device if we have device id
    if (deviceId) {
      if (Store.state.device.currentDevice && Store.state.device.currentDevice.device === deviceId) {
        return next()
      }
      // Load tenant's devices if necessary
      if (Store.state.device.sensors.length === 0) {
        await Store.dispatch('device/getSensors')
      }
      // The deviceId is not valid for this tenant select one
      Store.commit('device/setCurrentDevice', deviceId)
      if (!Store.state.device.currentDevice) {
        return next('/device/select')
      }
      return next()
    } else {
      return next('/device/select')
    }
  }
}

export default DeviceRouter
export { DeviceFilter }
